/*
This file is part of the Notesnook project (https://notesnook.com/)

Copyright (C) 2023 Streetwriters (Private) Limited

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU General Public License for more details.

You should have received a copy of the GNU General Public License
along with this program.  If not, see <http://www.gnu.org/licenses/>.
*/

const APP_VERSION_KEY = "notesnook:app-version";

export function isStaleChunkError(message: string) {
  return (
    message.includes("Failed to fetch dynamically imported module") ||
    message.includes("Importing a module script failed") ||
    message.includes("error loading dynamically imported module") ||
    message.includes("Unexpected token '<'") ||
    message.includes("Stale asset")
  );
}

/** Runtime stale-chunk errors must not reload the page (note open loads lazy chunks). */
export function recoverFromStaleChunk(_message: string) {
  return false;
}

export function persistAppVersionAfterLoad() {
  if (typeof APP_VERSION === "undefined") return;
  try {
    localStorage.setItem(APP_VERSION_KEY, APP_VERSION);
  } catch {
    /* private mode / blocked storage */
  }
}
